const loadedScripts = {};

export function loadScript(src, async) {
    const scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.type = 'text/javascript';
    scriptTag.async = async;

    if (!loadedScripts[src]) {
        loadedScripts[src] = new Promise(resolve => {
            scriptTag.onload = resolve;
            document.head.appendChild(scriptTag);
        });
    }

    return loadedScripts[src];
}
